export const SNACKBAR_PERSISTENT_DURATION = 6000;
